import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
Vue.use(VueRouter);
var routes = [
	{
		path: "/",
		name: "home",
		component: function() {
			return import("../pages/home.vue");
		}
	},
	{
		path: "/login",
		name: "login",
		component: function() {
			return import("../pages/login.vue");
		},
		meta: { layout: "empty-layout", allowanonymous: true }
	},
	{
		path: "/groupings",
		name: "groupings",
		component: function() {
			return import("../pages/grouping.vue");
		}
	},
	{
		path: "/scheduler",
		name: "scheduler",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: function() {
			return import(
				/* webpackChunkName: "about" */ "../pages/scheduler.vue"
			);
		}
	},
	{
		path: "/settings-tables",
		name: "settingsTables",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: function() {
			return import("../pages/settingsTable/settingsTableList.vue");
		},
		children: [
			// UserHome will be rendered inside User's <router-view>
			// overwrite default transition
			// when /user/:id is matched
			{
				path: "/settings-tables/:name",
				meta: { transition: "fade-in-down" },
				component: function() {
					return import(
						/* webpackChunkName: "about" */ "../pages/settingsTable/settingsTableMappingList.vue"
					);
				}
			},
			{
				path: "/settings-tables/:name/:id",
				meta: { transition: "fade-in-down" },
				component: function() {
					return import("../pages/settingsTable/tableTypeConfig.vue");
				}
			}

			// ...other sub routes
		]
	}
];
var router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: routes
});
export default router;
